<template>
  <div id ="googleMap" class="google-map"
    
  >
     

  </div>
</template>


<script>
import GoogleMapsLoader from 'google-maps'
 export default {
    name: 'google-map',
    props: ['name'],
    data () {
        return {
            center: { lat: 10.0, lng: 10.0},
            zoom: 7,
            position: {lat:61.180059, lng: -149.822075},

        }
    },

mounted: function () {
    GoogleMapsLoader.VERSION = '3.3.0';
    GoogleMapsLoader.KEY="AIzaSyCIY6u6MAMPYSef_gn8EBKbKxrlX14zQ90";
    const location = {lat:47.475700, 
                    lng: -122.283768
                }
    GoogleMapsLoader.load(function(google) {
        
        var map = new google.maps.Map(document.getElementById('googleMap'), {
        zoom: 15,
        center: location
        });

        new google.maps.Marker({position: location, map: map});
       
    })
    
    
}
    
};
</script>
<style  scoped>
    .google-map {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        background: grey
    }
    .mobile{
        width: 100%;
        height: 400px;
        margin: 0 auto;
        background: grey
    }
</style>


